// Triggers a print of the current page.
//
// On the web this opens the normal browser print dialog. But when the admin site
// is loaded inside a native app WebView (Android / iOS), a plain window.print()
// does nothing / can't produce a PDF. The app injects a bridge that we call
// instead so it can convert the page to a PDF:
//   - Android:  window.AndroidPrint.printPage()
//   - iOS:      window.webkit.messageHandlers.printHandler.postMessage('print')
//
// The site may be embedded via an <iframe>, so the bridge can live on the top
// window rather than the current one — we probe both (cross-origin access is
// wrapped in try/catch and simply skipped).
function bridgeFrames() {
  const frames = [window];
  try {
    if (window.top && window.top !== window) frames.push(window.top);
  } catch {
    /* cross-origin top frame — not reachable */
  }
  return frames;
}

// True when the page runs inside the native app (Android/iOS print bridge
// available). Callers use this to pick a print-to-PDF flow over downloads,
// which a WebView cannot perform.
export function hasNativePrintBridge() {
  for (const w of bridgeFrames()) {
    try {
      if (w.AndroidPrint && typeof w.AndroidPrint.printPage === "function") {
        return true;
      }
      if (w.webkit?.messageHandlers?.printHandler) return true;
    } catch {
      /* cross-origin frame — skip */
    }
  }
  return false;
}

export default function printPage() {
  const frames = bridgeFrames();

  for (const w of frames) {
    try {
      if (w.AndroidPrint && typeof w.AndroidPrint.printPage === "function") {
        w.AndroidPrint.printPage();
        return;
      }
      if (w.webkit?.messageHandlers?.printHandler) {
        w.webkit.messageHandlers.printHandler.postMessage("print");
        return;
      }
    } catch {
      /* cross-origin frame — skip */
    }
  }

  window.print();
}
